
// @ts-nocheck


export const localeCodes =  [
  "af",
  "am",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "cy",
  "da",
  "de",
  "dz",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "fi",
  "tl",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gu",
  "he",
  "hi",
  "hr",
  "ht",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "jv",
  "ka",
  "kk",
  "km",
  "kn",
  "ko",
  "ku",
  "ky",
  "lo",
  "lt",
  "lv",
  "mg",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "my",
  "ne",
  "nl",
  "oc",
  "pa",
  "pl",
  "pt",
  "ro",
  "ru",
  "si",
  "sk",
  "sl",
  "sq",
  "sr",
  "sv",
  "ta",
  "te",
  "th",
  "tr",
  "ug",
  "uk",
  "ur",
  "vi",
  "zh"
]

export const localeLoaders = {
  "af": [{ key: "../i18n/locales/af.json", load: () => import("../i18n/locales/af.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_af_json" */), cache: true }],
  "am": [{ key: "../i18n/locales/am.json", load: () => import("../i18n/locales/am.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_am_json" */), cache: true }],
  "ar": [{ key: "../i18n/locales/ar.json", load: () => import("../i18n/locales/ar.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ar_json" */), cache: true }],
  "az": [{ key: "../i18n/locales/az.json", load: () => import("../i18n/locales/az.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_az_json" */), cache: true }],
  "be": [{ key: "../i18n/locales/be.json", load: () => import("../i18n/locales/be.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_be_json" */), cache: true }],
  "bg": [{ key: "../i18n/locales/bg.json", load: () => import("../i18n/locales/bg.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_bg_json" */), cache: true }],
  "bn": [{ key: "../i18n/locales/bn.json", load: () => import("../i18n/locales/bn.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_bn_json" */), cache: true }],
  "bs": [{ key: "../i18n/locales/bs.json", load: () => import("../i18n/locales/bs.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_bs_json" */), cache: true }],
  "ca": [{ key: "../i18n/locales/ca.json", load: () => import("../i18n/locales/ca.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ca_json" */), cache: true }],
  "cs": [{ key: "../i18n/locales/cs.json", load: () => import("../i18n/locales/cs.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_cs_json" */), cache: true }],
  "cy": [{ key: "../i18n/locales/cy.json", load: () => import("../i18n/locales/cy.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_cy_json" */), cache: true }],
  "da": [{ key: "../i18n/locales/da.json", load: () => import("../i18n/locales/da.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_da_json" */), cache: true }],
  "de": [{ key: "../i18n/locales/de.json", load: () => import("../i18n/locales/de.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_de_json" */), cache: true }],
  "dz": [{ key: "../i18n/locales/dz.json", load: () => import("../i18n/locales/dz.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_dz_json" */), cache: true }],
  "el": [{ key: "../i18n/locales/el.json", load: () => import("../i18n/locales/el.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_el_json" */), cache: true }],
  "en": [{ key: "../i18n/locales/en.json", load: () => import("../i18n/locales/en.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_en_json" */), cache: true }],
  "eo": [{ key: "../i18n/locales/eo.json", load: () => import("../i18n/locales/eo.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_eo_json" */), cache: true }],
  "es": [{ key: "../i18n/locales/es.json", load: () => import("../i18n/locales/es.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_es_json" */), cache: true }],
  "et": [{ key: "../i18n/locales/et.json", load: () => import("../i18n/locales/et.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_et_json" */), cache: true }],
  "eu": [{ key: "../i18n/locales/eu.json", load: () => import("../i18n/locales/eu.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_eu_json" */), cache: true }],
  "fa": [{ key: "../i18n/locales/fa.json", load: () => import("../i18n/locales/fa.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_fa_json" */), cache: true }],
  "fi": [{ key: "../i18n/locales/fi.json", load: () => import("../i18n/locales/fi.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_fi_json" */), cache: true }],
  "tl": [{ key: "../i18n/locales/tl.json", load: () => import("../i18n/locales/tl.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_tl_json" */), cache: true }],
  "fr": [{ key: "../i18n/locales/fr.json", load: () => import("../i18n/locales/fr.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_fr_json" */), cache: true }],
  "fy": [{ key: "../i18n/locales/fy.json", load: () => import("../i18n/locales/fy.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_fy_json" */), cache: true }],
  "ga": [{ key: "../i18n/locales/ga.json", load: () => import("../i18n/locales/ga.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ga_json" */), cache: true }],
  "gd": [{ key: "../i18n/locales/gd.json", load: () => import("../i18n/locales/gd.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_gd_json" */), cache: true }],
  "gl": [{ key: "../i18n/locales/gl.json", load: () => import("../i18n/locales/gl.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_gl_json" */), cache: true }],
  "gu": [{ key: "../i18n/locales/gu.json", load: () => import("../i18n/locales/gu.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_gu_json" */), cache: true }],
  "he": [{ key: "../i18n/locales/he.json", load: () => import("../i18n/locales/he.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_he_json" */), cache: true }],
  "hi": [{ key: "../i18n/locales/hi.json", load: () => import("../i18n/locales/hi.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_hi_json" */), cache: true }],
  "hr": [{ key: "../i18n/locales/hr.json", load: () => import("../i18n/locales/hr.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_hr_json" */), cache: true }],
  "ht": [{ key: "../i18n/locales/ht.json", load: () => import("../i18n/locales/ht.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ht_json" */), cache: true }],
  "hu": [{ key: "../i18n/locales/hu.json", load: () => import("../i18n/locales/hu.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_hu_json" */), cache: true }],
  "hy": [{ key: "../i18n/locales/hy.json", load: () => import("../i18n/locales/hy.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_hy_json" */), cache: true }],
  "id": [{ key: "../i18n/locales/id.json", load: () => import("../i18n/locales/id.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_id_json" */), cache: true }],
  "is": [{ key: "../i18n/locales/is.json", load: () => import("../i18n/locales/is.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_is_json" */), cache: true }],
  "it": [{ key: "../i18n/locales/it.json", load: () => import("../i18n/locales/it.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_it_json" */), cache: true }],
  "ja": [{ key: "../i18n/locales/ja.json", load: () => import("../i18n/locales/ja.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ja_json" */), cache: true }],
  "jv": [{ key: "../i18n/locales/jv.json", load: () => import("../i18n/locales/jv.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_jv_json" */), cache: true }],
  "ka": [{ key: "../i18n/locales/ka.json", load: () => import("../i18n/locales/ka.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ka_json" */), cache: true }],
  "kk": [{ key: "../i18n/locales/kk.json", load: () => import("../i18n/locales/kk.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_kk_json" */), cache: true }],
  "km": [{ key: "../i18n/locales/km.json", load: () => import("../i18n/locales/km.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_km_json" */), cache: true }],
  "kn": [{ key: "../i18n/locales/kn.json", load: () => import("../i18n/locales/kn.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_kn_json" */), cache: true }],
  "ko": [{ key: "../i18n/locales/ko.json", load: () => import("../i18n/locales/ko.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ko_json" */), cache: true }],
  "ku": [{ key: "../i18n/locales/ku.json", load: () => import("../i18n/locales/ku.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ku_json" */), cache: true }],
  "ky": [{ key: "../i18n/locales/ky.json", load: () => import("../i18n/locales/ky.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ky_json" */), cache: true }],
  "lo": [{ key: "../i18n/locales/lo.json", load: () => import("../i18n/locales/lo.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_lo_json" */), cache: true }],
  "lt": [{ key: "../i18n/locales/lt.json", load: () => import("../i18n/locales/lt.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_lt_json" */), cache: true }],
  "lv": [{ key: "../i18n/locales/lv.json", load: () => import("../i18n/locales/lv.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_lv_json" */), cache: true }],
  "mg": [{ key: "../i18n/locales/mg.json", load: () => import("../i18n/locales/mg.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_mg_json" */), cache: true }],
  "mk": [{ key: "../i18n/locales/mk.json", load: () => import("../i18n/locales/mk.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_mk_json" */), cache: true }],
  "ml": [{ key: "../i18n/locales/ml.json", load: () => import("../i18n/locales/ml.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ml_json" */), cache: true }],
  "mn": [{ key: "../i18n/locales/mn.json", load: () => import("../i18n/locales/mn.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_mn_json" */), cache: true }],
  "mr": [{ key: "../i18n/locales/mr.json", load: () => import("../i18n/locales/mr.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_mr_json" */), cache: true }],
  "ms": [{ key: "../i18n/locales/ms.json", load: () => import("../i18n/locales/ms.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ms_json" */), cache: true }],
  "my": [{ key: "../i18n/locales/my.json", load: () => import("../i18n/locales/my.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_my_json" */), cache: true }],
  "ne": [{ key: "../i18n/locales/ne.json", load: () => import("../i18n/locales/ne.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ne_json" */), cache: true }],
  "nl": [{ key: "../i18n/locales/nl.json", load: () => import("../i18n/locales/nl.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_nl_json" */), cache: true }],
  "oc": [{ key: "../i18n/locales/oc.json", load: () => import("../i18n/locales/oc.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_oc_json" */), cache: true }],
  "pa": [{ key: "../i18n/locales/pa.json", load: () => import("../i18n/locales/pa.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_pa_json" */), cache: true }],
  "pl": [{ key: "../i18n/locales/pl.json", load: () => import("../i18n/locales/pl.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_pl_json" */), cache: true }],
  "pt": [{ key: "../i18n/locales/pt.json", load: () => import("../i18n/locales/pt.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_pt_json" */), cache: true }],
  "ro": [{ key: "../i18n/locales/ro.json", load: () => import("../i18n/locales/ro.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ro_json" */), cache: true }],
  "ru": [{ key: "../i18n/locales/ru.json", load: () => import("../i18n/locales/ru.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ru_json" */), cache: true }],
  "si": [{ key: "../i18n/locales/si.json", load: () => import("../i18n/locales/si.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_si_json" */), cache: true }],
  "sk": [{ key: "../i18n/locales/sk.json", load: () => import("../i18n/locales/sk.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_sk_json" */), cache: true }],
  "sl": [{ key: "../i18n/locales/sl.json", load: () => import("../i18n/locales/sl.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_sl_json" */), cache: true }],
  "sq": [{ key: "../i18n/locales/sq.json", load: () => import("../i18n/locales/sq.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_sq_json" */), cache: true }],
  "sr": [{ key: "../i18n/locales/sr.json", load: () => import("../i18n/locales/sr.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_sr_json" */), cache: true }],
  "sv": [{ key: "../i18n/locales/sv.json", load: () => import("../i18n/locales/sv.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_sv_json" */), cache: true }],
  "ta": [{ key: "../i18n/locales/ta.json", load: () => import("../i18n/locales/ta.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ta_json" */), cache: true }],
  "te": [{ key: "../i18n/locales/te.json", load: () => import("../i18n/locales/te.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_te_json" */), cache: true }],
  "th": [{ key: "../i18n/locales/th.json", load: () => import("../i18n/locales/th.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_th_json" */), cache: true }],
  "tr": [{ key: "../i18n/locales/tr.json", load: () => import("../i18n/locales/tr.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_tr_json" */), cache: true }],
  "ug": [{ key: "../i18n/locales/ug.json", load: () => import("../i18n/locales/ug.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ug_json" */), cache: true }],
  "uk": [{ key: "../i18n/locales/uk.json", load: () => import("../i18n/locales/uk.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_uk_json" */), cache: true }],
  "ur": [{ key: "../i18n/locales/ur.json", load: () => import("../i18n/locales/ur.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_ur_json" */), cache: true }],
  "vi": [{ key: "../i18n/locales/vi.json", load: () => import("../i18n/locales/vi.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_vi_json" */), cache: true }],
  "zh": [{ key: "../i18n/locales/zh.json", load: () => import("../i18n/locales/zh.json" /* webpackChunkName: "locale__usr_src_app_i18n_locales_zh_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute"
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": true
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "nativeName": "Afrikaans",
      "name": "Afrikaans",
      "code": "af",
      "language": "af",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/af.json"
      ]
    },
    {
      "nativeName": "አማርኛ",
      "name": "Amharic",
      "code": "am",
      "language": "am",
      "dir": "rtl",
      "files": [
        "/usr/src/app/i18n/locales/am.json"
      ]
    },
    {
      "nativeName": "العربية",
      "name": "Arabic",
      "code": "ar",
      "language": "ar",
      "dir": "rtl",
      "files": [
        "/usr/src/app/i18n/locales/ar.json"
      ]
    },
    {
      "nativeName": "Azərbaycanca",
      "name": "Azerbaijani",
      "code": "az",
      "language": "az",
      "dir": "rtl",
      "files": [
        "/usr/src/app/i18n/locales/az.json"
      ]
    },
    {
      "nativeName": "Беларуская",
      "name": "Belarusian",
      "code": "be",
      "language": "be",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/be.json"
      ]
    },
    {
      "nativeName": "Български",
      "name": "Bulgarian",
      "code": "bg",
      "language": "bg",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/bg.json"
      ]
    },
    {
      "nativeName": "বাংলা",
      "name": "Bengali",
      "code": "bn",
      "language": "bn",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/bn.json"
      ]
    },
    {
      "nativeName": "Bosanski",
      "name": "Bosnian",
      "code": "bs",
      "language": "bs",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/bs.json"
      ]
    },
    {
      "nativeName": "Català",
      "name": "Catalan",
      "code": "ca",
      "language": "ca",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ca.json"
      ]
    },
    {
      "nativeName": "Čeština",
      "name": "Czech",
      "code": "cs",
      "language": "cs",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/cs.json"
      ]
    },
    {
      "nativeName": "Cymraeg",
      "name": "Welsh",
      "code": "cy",
      "language": "cy",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/cy.json"
      ]
    },
    {
      "nativeName": "Dansk",
      "name": "Danish",
      "code": "da",
      "language": "da",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/da.json"
      ]
    },
    {
      "nativeName": "Deutsch",
      "name": "German",
      "code": "de",
      "language": "de",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/de.json"
      ]
    },
    {
      "nativeName": "རྫོང་ཁ",
      "name": "Dzongkha",
      "code": "dz",
      "language": "dz",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/dz.json"
      ]
    },
    {
      "nativeName": "Ελληνικά",
      "name": "Greek",
      "code": "el",
      "language": "el",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/el.json"
      ]
    },
    {
      "nativeName": "English",
      "name": "English",
      "code": "en",
      "language": "en",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/en.json"
      ]
    },
    {
      "nativeName": "Esperanto",
      "name": "Esperanto",
      "code": "eo",
      "language": "eo",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/eo.json"
      ]
    },
    {
      "nativeName": "Español",
      "name": "Spanish",
      "code": "es",
      "language": "es",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/es.json"
      ]
    },
    {
      "nativeName": "Eesti",
      "name": "Estonian",
      "code": "et",
      "language": "et",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/et.json"
      ]
    },
    {
      "nativeName": "Euskera",
      "name": "Basque",
      "code": "eu",
      "language": "eu",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/eu.json"
      ]
    },
    {
      "nativeName": "فارسی",
      "name": "Persian, Farsi",
      "code": "fa",
      "language": "fa",
      "dir": "rtl",
      "files": [
        "/usr/src/app/i18n/locales/fa.json"
      ]
    },
    {
      "nativeName": "Suomi",
      "name": "Finnish",
      "code": "fi",
      "language": "fi",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/fi.json"
      ]
    },
    {
      "nativeName": "Filipino",
      "name": "Filipino",
      "code": "tl",
      "language": "tl",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/tl.json"
      ]
    },
    {
      "nativeName": "Français",
      "name": "French",
      "code": "fr",
      "language": "fr",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/fr.json"
      ]
    },
    {
      "nativeName": "Frysk",
      "name": "Frisian, Western",
      "code": "fy",
      "language": "fy",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/fy.json"
      ]
    },
    {
      "nativeName": "Gaeilge",
      "name": "Irish",
      "code": "ga",
      "language": "ga",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ga.json"
      ]
    },
    {
      "nativeName": "Gàidhlig",
      "name": "Scots Gaelic",
      "code": "gd",
      "language": "gd",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/gd.json"
      ]
    },
    {
      "nativeName": "Galego",
      "name": "Galician",
      "code": "gl",
      "language": "gl",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/gl.json"
      ]
    },
    {
      "nativeName": "ગુજરાતી",
      "name": "Gujarati",
      "code": "gu",
      "language": "gu",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/gu.json"
      ]
    },
    {
      "nativeName": "עברית",
      "name": "Hebrew",
      "code": "he",
      "language": "he",
      "dir": "rtl",
      "files": [
        "/usr/src/app/i18n/locales/he.json"
      ]
    },
    {
      "nativeName": "हिन्दी",
      "name": "Hindi",
      "code": "hi",
      "language": "hi",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/hi.json"
      ]
    },
    {
      "nativeName": "Hrvatski",
      "name": "Croatian",
      "code": "hr",
      "language": "hr",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/hr.json"
      ]
    },
    {
      "nativeName": "Kreyòl ayisyen",
      "name": "Haitian Creole",
      "code": "ht",
      "language": "ht",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ht.json"
      ]
    },
    {
      "nativeName": "Magyar",
      "name": "Hungarian",
      "code": "hu",
      "language": "hu",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/hu.json"
      ]
    },
    {
      "nativeName": "Հայերեն",
      "name": "Armenian",
      "code": "hy",
      "language": "hy",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/hy.json"
      ]
    },
    {
      "nativeName": "Bahasa Indonesia",
      "name": "Indonesian",
      "code": "id",
      "language": "id",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/id.json"
      ]
    },
    {
      "nativeName": "Íslenska",
      "name": "Icelandic",
      "code": "is",
      "language": "is",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/is.json"
      ]
    },
    {
      "nativeName": "Italiano",
      "name": "Italian",
      "code": "it",
      "language": "it",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/it.json"
      ]
    },
    {
      "nativeName": "日本語",
      "name": "Japanese",
      "code": "ja",
      "language": "ja",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ja.json"
      ]
    },
    {
      "nativeName": "Basa Java",
      "name": "Javanese",
      "code": "jv",
      "language": "jv",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/jv.json"
      ]
    },
    {
      "nativeName": "ქართული ენა",
      "name": "Georgian",
      "code": "ka",
      "language": "ka",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ka.json"
      ]
    },
    {
      "nativeName": "Қазақ",
      "name": "Kazakh",
      "code": "kk",
      "language": "kk",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/kk.json"
      ]
    },
    {
      "nativeName": "ភាសាខ្មែរ",
      "name": "Khmer",
      "code": "km",
      "language": "km",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/km.json"
      ]
    },
    {
      "nativeName": "ಕನ್ನಡ",
      "name": "Kannada",
      "code": "kn",
      "language": "kn",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/kn.json"
      ]
    },
    {
      "nativeName": "한국어",
      "name": "Korean",
      "code": "ko",
      "language": "ko",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ko.json"
      ]
    },
    {
      "nativeName": "Kurdî",
      "name": "Kurdish",
      "code": "ku",
      "language": "ku",
      "dir": "rtl",
      "files": [
        "/usr/src/app/i18n/locales/ku.json"
      ]
    },
    {
      "nativeName": "Кыргызча",
      "name": "Kyrgyz",
      "code": "ky",
      "language": "ky",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ky.json"
      ]
    },
    {
      "nativeName": "ພາສາລາວ",
      "name": "Lao",
      "code": "lo",
      "language": "lo",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/lo.json"
      ]
    },
    {
      "nativeName": "Lietuvių",
      "name": "Lithuanian",
      "code": "lt",
      "language": "lt",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/lt.json"
      ]
    },
    {
      "nativeName": "Latviešu",
      "name": "Latvian",
      "code": "lv",
      "language": "lv",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/lv.json"
      ]
    },
    {
      "nativeName": "Malagasy",
      "name": "Malagasy",
      "code": "mg",
      "language": "mg",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/mg.json"
      ]
    },
    {
      "nativeName": "Македонски",
      "name": "Macedonian",
      "code": "mk",
      "language": "mk",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/mk.json"
      ]
    },
    {
      "nativeName": "മലയാളം",
      "name": "Malayalam",
      "code": "ml",
      "language": "ml",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ml.json"
      ]
    },
    {
      "nativeName": "монгол",
      "name": "Mongolian",
      "code": "mn",
      "language": "mn",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/mn.json"
      ]
    },
    {
      "nativeName": "मराठी",
      "name": "Marathi",
      "code": "mr",
      "language": "mr",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/mr.json"
      ]
    },
    {
      "nativeName": "بهاس ملايو",
      "name": "Bahasa Malaysia",
      "code": "ms",
      "language": "ms",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ms.json"
      ]
    },
    {
      "nativeName": "ဗမာစကား",
      "name": "Burmese",
      "code": "my",
      "language": "my",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/my.json"
      ]
    },
    {
      "nativeName": "नेपाली",
      "name": "Nepali",
      "code": "ne",
      "language": "ne",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ne.json"
      ]
    },
    {
      "nativeName": "Nederlands",
      "name": "Dutch",
      "code": "nl",
      "language": "nl",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/nl.json"
      ]
    },
    {
      "nativeName": "Occitan",
      "name": "Occitan",
      "code": "oc",
      "language": "oc",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/oc.json"
      ]
    },
    {
      "nativeName": "ਪੰਜਾਬੀ",
      "name": "Punjabi",
      "code": "pa",
      "language": "pa",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/pa.json"
      ]
    },
    {
      "nativeName": "Polski",
      "name": "Polish",
      "code": "pl",
      "language": "pl",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/pl.json"
      ]
    },
    {
      "nativeName": "Português, Portugal",
      "name": "Portuguese, Portugal",
      "code": "pt",
      "language": "pt",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/pt.json"
      ]
    },
    {
      "nativeName": "Română",
      "name": "Romanian",
      "code": "ro",
      "language": "ro",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ro.json"
      ]
    },
    {
      "nativeName": "Русский",
      "name": "Russian",
      "code": "ru",
      "language": "ru",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ru.json"
      ]
    },
    {
      "nativeName": "සිංහල",
      "name": "Sinhala",
      "code": "si",
      "language": "si",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/si.json"
      ]
    },
    {
      "nativeName": "Slovenčina",
      "name": "Slovak",
      "code": "sk",
      "language": "sk",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/sk.json"
      ]
    },
    {
      "nativeName": "Slovenščina",
      "name": "Slovenian",
      "code": "sl",
      "language": "sl",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/sl.json"
      ]
    },
    {
      "nativeName": "Shqip",
      "name": "Albanian",
      "code": "sq",
      "language": "sq",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/sq.json"
      ]
    },
    {
      "nativeName": "Српски",
      "name": "Serbian",
      "code": "sr",
      "language": "sr",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/sr.json"
      ]
    },
    {
      "nativeName": "Svenska",
      "name": "Swedish",
      "code": "sv",
      "language": "sv",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/sv.json"
      ]
    },
    {
      "nativeName": "தமிழ்",
      "name": "Tamil",
      "code": "ta",
      "language": "ta",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ta.json"
      ]
    },
    {
      "nativeName": "తెలుగు",
      "name": "Telugu",
      "code": "te",
      "language": "te",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/te.json"
      ]
    },
    {
      "nativeName": "ภาษาไทย",
      "name": "Thai",
      "code": "th",
      "language": "th",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/th.json"
      ]
    },
    {
      "nativeName": "Türkçe",
      "name": "Turkish",
      "code": "tr",
      "language": "tr",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/tr.json"
      ]
    },
    {
      "nativeName": "ئۇيغۇرچە",
      "name": "Uyghur",
      "code": "ug",
      "language": "ug",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/ug.json"
      ]
    },
    {
      "nativeName": "Українська",
      "name": "Ukrainian",
      "code": "uk",
      "language": "uk",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/uk.json"
      ]
    },
    {
      "nativeName": "اردو",
      "name": "Urdu",
      "code": "ur",
      "language": "ur",
      "dir": "rtl",
      "files": [
        "/usr/src/app/i18n/locales/ur.json"
      ]
    },
    {
      "nativeName": "Tiếng Việt",
      "name": "Vietnamese",
      "code": "vi",
      "language": "vi",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/vi.json"
      ]
    },
    {
      "nativeName": "简体中文",
      "name": "Chinese, Simplified",
      "code": "zh",
      "language": "zh",
      "dir": "ltr",
      "files": [
        "/usr/src/app/i18n/locales/zh.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "/en",
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "messages": {
    "en": {
      "Notification": "Notification",
      "National Targets": "National Targets",
      "View more national targets": "View more national targets",
      "Meeting": "Meeting",
      "Comments": "Comments",
      "Waiting for Approval": "Waiting for Approval",
      "Edit Mode": "Edit Mode",
      "LazyPageHeaderMegaMenuCustomFocalPoints": "Focal Points Menu Component",
      "LazyPageHeaderMegaMenuCustomFocalPointsDesc": "Is 100% auto generated from the the SCBD's apis.",
      "isNotEditable": "(not editable but can be disabled for removed)",
      "isEditable": "(is editable but can be disabled for removed)",
      "Sticky": "Sticky",
      "stickyNote": "Record sticks to the top of lists.",
      "Logout": "Logout",
      "Edit mode": "Edit mode",
      "Promote": "Promote",
      "promoteNote": "Record promoted to show on home page.",
      "Publishing": "Publishing",
      "Structure": "Structure",
      "Configuration": "Configuration",
      "Content": "Content",
      "People": "People",
      "Reports": "Reports",
      "editCacheNotice": "Clearing the cache for the page can take approximately a minute.  Otherwise changes may be reflected in 1 - 24 hours.",
      "This is a development/pre-production website": "This is a development/pre-production website",
      "This is a staging website to review Bioland 2 and migrations": "This is a staging website to review Bioland 2 and migrations",
      "ecosystem": "ecosystem | ecosystems",
      "project": "project | projects",
      "biodiversity-data": "biodiversity data | biodiversity data sets",
      "event": "Events",
      "protected-area": "protected area | protected areas",
      "web-page": "web page | web pages",
      "learning-resource": "learning resource | learning resources",
      "news": "news",
      "government-ministry-or-institute": "government ministry or institute | government ministries and institutes",
      "document": "document | documents",
      "image": "image | images",
      "video": "video | videos",
      "remote_video": "video | videos",
      "photos-and-videos": "photo or video | photos & videos",
      "search": "search",
      "content": "site content",
      "secretariate": "secretariate",
      "notification": "Notifications",
      "statement": "Statements",
      "meeting": "Meetings",
      "pressRelease": "Press Releases",
      "focalPoint": "National Focal Points",
      "resource": "Virtual Library Resources",
      "organization": "Organizations",
      "capacityBuildingInitiative": "Capacity-building Initiatives",
      "contact": "contact",
      "modelContractualClause": "model contractual clause",
      "communityProtocol": "community protocol",
      "absNationalReport": "abs national report",
      "absCheckpointCommunique": "abs checkpoint communique",
      "absCheckpoint": "Checkpoint Communiqués",
      "absPermit": "Internationally Recognized Certificates of Compliance",
      "authority": "authority",
      "supplementaryAuthority": "supplementary authority",
      "cpbNationalReport4": "cpb national report 4",
      "cpbNationalReport3": "cpb national report 3",
      "cpbNationalReport2": "cpb national report 2",
      "biosafetyNews": "biosafety news",
      "independentRiskAssessment": "independent risk assessment",
      "organism": "organism",
      "dnaSequence": "dna sequence",
      "modifiedOrganism": "modified organism",
      "laboratoryDetection": "laboratory detection",
      "Secretariat": "Secretariat",
      "secretariat": "secretariat",
      "Biosafety Clearing-House": "Biosafety Clearing-House",
      "Access and Benefit-sharing Clearing-House": "Access and Benefit-sharing Clearing-House",
      "image-or-video": "photos & videos",
      "Topic": "Topic",
      "Reply": "Reply",
      "Forums": "Forums",
      "Forum": "Forum",
      "Topics": "Topics",
      "Posts": "Posts",
      "Last Post": "Last Post ",
      "By": "By",
      "Site Content": "Site Content",
      "Replies": "Replies",
      "Last Reply": "Last Reply",
      "bbiRequest": "BBI Request",
      "Basic Page": "Basic Page",
      "Filter by Type:": "Filter by Type:",
      "Image": "Image",
      "Document": "Document",
      "Remote Video": "Remote Video",
      "Video": "Video",
      "View more": "View more",
      "from the secretariat": "from the secretariat",
      "GBF Targets": "GBF Targets",
      "Protected Areas": "Protected Areas",
      "Protected Area": "Protected Area",
      "Related Media": "Related Media",
      "Published on": "Published on",
      "SDG's": "SDG's",
      "Countries": "Countries",
      "Thematic Areas": "Thematic Areas",
      "Ecosystems": "Ecosystems",
      "Ecosystem": "Ecosystem",
      "Biodiversity Data": "Biodiversity Data",
      "Content Type": "Content Type",
      "Projects": "Projects",
      "Project": "Project",
      "News": "News",
      "Events": "Events",
      "Events and News": "Events and News",
      "Event": "Event",
      "Attachments": "Attachments",
      "United Nations": "United Nations",
      "Convention on Biological Diversity": "Convention on Biological Diversity",
      "Convention on": "Convention on",
      "Biological Diversity": "Biological Diversity",
      "Welcome to the Convention on Biological Diversity CHM Network": "Welcome to the Convention on Biological Diversity CHM Network",
      "Other": "Other",
      "Search this site": "Search this site",
      "Secretariat of the Convention on Biological Diversity": "Secretariat of the Convention on Biological Diversity",
      "Clearing House Mechanism": "Clearing House Mechanism",
      "Bioland Biodiversity": "Bioland Biodiversity",
      "Home": "Home",
      "Biodiversity CHM": "Biodiversity CHM",
      "National Reports": "National Reports",
      "View all National Reports": "View all National Reports",
      "section1": "Section I. Information on the targets being pursued at the national level",
      "section2": "Section II. Implementation measures, their effectiveness, and associated obstacles and scientific and technical needs to achieve national targets",
      "section3": "Section III. Assessment of progress towards each national target",
      "section4": "Section IV. Description of national contribution to the achievement of each global Aichi Biodiversity Target",
      "National Report": "National Report",
      "View all NBSAPs": "View all NBSAPs",
      "measure": "Legislative, Administrative or Policy Measures",
      "absProcedure": "ABS Procedures",
      "absNationalModelContractualClause": "National Model Contractual Clauses",
      "database-abs": "National Websites or Databases",
      "View in ABS Portal": "View in ABS Portal",
      "absch": "Access and Benefit-sharing (ABSCH)",
      "Country Profiles": "Country Profiles",
      "Country Profile": "Country Profile",
      "CBD": "CBD",
      "BCH": "BCH",
      "ABSCH": "ABSCH",
      "UN": "UN",
      "InforMEA": "InforMEA",
      "CBD-FP1": "CBD National Focal Point",
      "CBD-FP2": "Secondary Convention on Biological Diversity",
      "ABS-FP": "ABS National Focal Point",
      "ABSCH-FP": "ABSCH Focal Point",
      "CPB-FP1": "CPB National Focal Point",
      "CPB-A17-FP": "Emergency Measures (Article 17) Contact Point",
      "RM-FP": "Resource Mobilization Focal Point",
      "PA-FP": "Programme of Work on Protected Areas Focal Point",
      "TKBD-FP": "Traditional Knowledge Focal Point",
      "SBSTTA-FP": "Subsidiary Body on Scientific, Technical and Technological Advice (SBSTTA) Focal Point",
      "GTI-FP": "Global Taxonomy Initiative Focal Point",
      "GSPC-FP": "Global Strategy for Plant Conservation Focal Point",
      "CHM-FP": "CHM Focal Point",
      "BCH-FP": "BCH Focal Point",
      "ABS": "Nagoya Protocol on Access and Benefit-sharing",
      "CPB": "Cartagena Protocol on Biosafety",
      "RM": "Resource Mobilization",
      "PA": "Programme of Work on Protected Areas",
      "TKBD": "Traditional Knowledge",
      "SBSTTA": "Subsidiary Body on Scientific, Technical and Technological Advice (SBSTTA)",
      "GTI": "Global Taxonomy Initiative",
      "GSPC": "Global Strategy for Plant Conservation",
      "CHM-NFP": "CHM NFP",
      "BCH-NFP": "BCH NFP",
      "National Focal Points": "National Focal Points",
      "National Contact Points": "National Contact Points",
      "view": "View",
      "bch-authority": "BCH Competent National Authority | BCH Competent National Authorities",
      "absch-authority": "ABSCH Competent National Authority | ABSCH Competent National Authorities",
      "bch-supplementaryAuthority": "BCH Supplementary Competent National Authority | BCH Supplementary Competent National Authorities",
      "replies": "replies",
      "View NBSAP": "View NBSAP",
      "biosafetyLaw": "Biosafety Laws, Regulations, Guidelines and Agreements",
      "biosafetyDecision": "Countries' Decisions or any other Communications",
      "nationalRiskAssessment": "Risk Assessments generated by a regulatory process",
      "database": "National Biosafety Websites or Databases",
      "nationalReport": "National Reports and NBSAPs",
      "biosafetyExpert": "Biosafety Experts",
      "countryProfile": "Country Profile",
      "View in BCH Portal": "View in BCH Portal",
      "bch": "Biosafety (BCH)",
      "Next": "Next",
      "Previous": "Previous",
      "Free text search": "Free text search",
      "Start Date": "Start Date",
      "End Date": "End Date",
      "Published on:": "Published on:",
      "National CHM": "National CHM",
      "record": "record | records",
      "File Name": "File Name",
      "Caption": "Caption",
      "Height": "Height",
      "px": "px",
      "Width": "Width",
      "Mime Type": "Mime Type",
      "File Size": "File Size",
      "Created Date": "Created Date",
      "Updated Date": "Updated Date",
      "Download": "Download",
      "Latest News and Updates": "Latest News and Updates",
      "View more news and updates": "View more news and updates",
      "implementation": "implementation",
      "Browse TSC Opportunities": "Browse TSC Opportunities",
      "Browse TSC Assistance and Providers": "Browse TSC Assistance and Providers",
      "Request TSC Assistance": "Request TSC Assistance",
      "Provide TSC Assistance": "Provide TSC Assistance",
      "Provide TSC Opportunity": "Provide TSC Opportunity",
      "View National Reports": "View National Reports",
      "View Laws & Regulations": "View Laws & Regulations",
      "View NBSAP(s)": "View NBSAP(s)",
      "View Projects": "View Projects",
      "View Documents": "View Documents",
      "Browse Courses": "Browse Courses",
      "Latest Discussions": "Latest Discussions",
      "Browse Discussions": "Browse Discussions",
      "GBIF": "GBIF",
      "Occurrence": "Species records",
      "Datasets": "Datasets",
      "Publishers": "Data publishers",
      "Browse Solutions": "Browse Solutions",
      "Panorama Solutions": "Panorama Solutions",
      "solution": "solution",
      "View all GBIF Data": "View all GBIF Data",
      "e-Learning": "e-Learning",
      "Technical & scientific cooperation": "Technical & scientific cooperation",
      "cancel": "Cancel",
      "info": "Info",
      "read more": "Read more",
      "arrow up": "Arrow up",
      "arrow down": "Arrow down",
      "menu": "Menu",
      "arrow right": "Arrow right",
      "external link": "External link",
      "loading": "Loading",
      "View": "View",
      "Edit": "Edit",
      "Delete": "Delete",
      "Revisions": "Revisions",
      "Clone": "Clone",
      "Translate": "Translate",
      "BBI Contacts": "BBI Contacts",
      "Bioland 1": "Bioland 1",
      "Write a public comment ...": "Write a public comment ...",
      "Login or sign up": "Login or sign up",
      "Post": "Post",
      "Login": "Login",
      "Sign up": "Sign up",
      "comment": "comment | comments",
      "reply": "reply | replies",
      "like": "like | likes",
      "share": "share | shares",
      "Unprocessable Entity": "Unprocessable Entity",
      "Failed to POST comment": "Failed to POST comment",
      "all": "all",
      "for an account in order to comment or interact.": "for an account in order to comment or interact.",
      "Sign Up": "Sign Up",
      "CBD-type": "Convention on Biological Diversity",
      "CPB-FP1-type": "Cartagena Protocol on Biosafety",
      "ABS-FP-type": "Nagoya Protocol on Access and Benefit-sharing",
      "CHM-FP-type": "Clearing-House Mechanism",
      "BCH-FP-type": "Biosafety Clearing-House",
      "CPB-A17-FP-type": "Emergency Measures (Article 17)",
      "RM-FP-type": "Resource Mobilization",
      "PA-FP-type": "Protected Areas",
      "TKBD-FP-type": "Traditional Knowledge",
      "SBSTTA-FP-type": "Subsidiary Body on Scientific, Technical and Technological Advice",
      "GTI-FP-type": "Global Taxonomy Initiative",
      "GSPC-FP-type": "Global Strategy for Plant Conservation",
      "united": "united",
      "nations": "nations",
      "forums": "forums",
      "CCA4B662-8EF4-418D-B327-0D6F418AA703": "Africa - All countries",
      "A23DD6C0-44C5-418D-83B5-461D79D2721A": "Africa - Middle Africa",
      "0938DB0F-E4BB-464F-ABBB-ADD615BE5371": "Africa - Eastern Africa",
      "39AF4BA6-E769-4013-B5F2-91B2E5BACB27": "Africa - Northern Africa",
      "BA8BAEF5-821C-43A6-8700-5CC215D4B5B0": "Africa - Southern Africa",
      "AEF6F814-52C0-4F1A-9838-5799B021BA26": "Africa - Western Africa",
      "E0006E60-E0D9-4196-855F-8456F0C38690": "Africa - African Union",
      "46358A41-9D1D-4B13-A5D2-DE9CAA1DF1C7": "Africa - Economic Commission for Africa",
      "21C5AE1A-B050-4EEB-8A3D-FE8BC3EB33B1": "Africa - Economic Community of West African States",
      "99AB05D6-1FB0-4369-A673-C266A80D3004": "Africa - Southern African Development Community",
      "2c311a50-e5ba-4463-b780-2bebc578697b": "Africa - Union Economique et Monétaire Ouest Africaine",
      "14E81A9D-73EA-4667-A699-CD78C61B3655": "Americas - All countries",
      "E9E917DF-872A-4B01-B152-B019E53D046E": "Americas - Caribbean",
      "90DBC1E4-AFD0-4FB4-B9EE-4CA2CB5D2C36": "Americas - Central America",
      "8317D3CB-6CAB-4C05-BC2C-2DB93A8FEC6A": "Americas - Northern America",
      "C9A535FB-8B15-4BD5-9AC7-9A9783871A5A": "Americas - South America",
      "005BDEA9-4063-4CD8-8E56-14D75E02D8A7": "Americas - Amazon Cooperation Treaty",
      "9C5E1A4D-E8EE-4C74-B9C9-5C7BCDF6B84A": "Americas - Andean Pact",
      "11E24235-03ED-4D1A-A1FE-FF2798B06240": "Americas - Asociacion Latinoamericana de Integracion",
      "25806FD6-C329-4878-8032-8832C92B3557": "Americas - Association of Caribbean States",
      "89FB902F-5060-4B12-9C84-A2B8F5F45DBF": "Americas - Comision Centroamericana de Ambiente y Desarrollo",
      "CFCF6D60-8800-4B1F-B404-5E1FC60CEEB7": "Americas - Economic Commission for Latin America and the Caribbean",
      "0D93D0A4-3DE8-49A9-8825-1237ACBCDD60": "Americas - Mercosur",
      "6C734879-5007-47F8-A931-C9A90B17DFA5": "Americas - The Caribbean Community (Caricom)",
      "3BED3C61-C8C5-49D8-9AFA-0B4D03FC427F": "Asia - All countries",
      "1CF17830-479B-42DD-AC6C-974E86EABE15": "Asia - Central Asia",
      "8962A223-E1F2-4200-905C-51B6FEF79FFE": "Asia - Eastern Asia",
      "B462BE9E-38A6-4DE0-997D-2CC07853379F": "Asia - Southern Asia",
      "B6C14B25-FDF6-4FA1-97A2-561D6B43FA80": "Asia - South-Eastern Asia",
      "70AD3B5C-9390-4E11-B4FB-60B5591037FA": "Asia - Western Asia",
      "99724A74-6CCD-4731-B111-9EEDF2612303": "Asia - Association of Southeast Asian Nations",
      "2A2161ED-B501-4022-BDF0-8AC5F0E6A512": "Asia-Pacific - Economic and Social Commission for Asia and the Pacific",
      "57FB8FD1-7EBF-4271-9788-3716DAFEE347": "Asia - Economic and Social Commission for Western Asia",
      "581432E3-4880-410D-ACBC-44B958B0E5AC": "Asia - South Asia Cooperative Environment Programme",
      "613675B2-B56D-454B-8817-54FE2A0DC3AF": "Asia-Pacific - Pacific Small Islands countries",
      "884FADBA-3BF3-4D76-AC7B-83E076852CD4": "Europe - All countries",
      "11D3515A-2C70-4766-B07C-E538AA16554B": "Europe - Northern Europe",
      "3B22777F-BD43-4DED-8379-EB3829BB53A5": "Europe - Southern Europe",
      "DB6CE7B5-EE86-41B1-A3A8-726E5A76C4F9": "Europe - Western Europe",
      "7DCF92D5-8412-4CFA-A67C-C6AA7A0A69F2": "Europe - Eastern Europe",
      "bd12d7fb-91f7-4b2d-996c-e70f18a51f0e": "Europe - European Union member states",
      "6DD4D22F-CFAE-4C2C-A2B5-4EC8386925DE": "Europe - Economic Commission for Europe",
      "0C201C06-3E4E-4044-85E0-DAE5DCE0F2C1": "Europe - European Free Trade Association",
      "C595105F-C5E7-4DF3-A68D-93CC9DAB900F": "Europe - Visegrad Group",
      "E5AA1403-308B-495F-9117-9F516F973C77": "Eurasia - Commonwealth of Independent States",
      "B52F76F8-B8A4-4381-8A78-E0BAD505AEBE": "Eurasia - Pan-European Biological and Landscape Diversity Strategy",
      "284697B9-D1C2-426B-890A-1ADBAC8EC477": "Oceania - All countries",
      "E9BAA797-CDAE-497E-A860-87AE784F4C53": "Oceania - Australia and New Zealand",
      "743D2F85-8ABA-4F35-BC83-30D295343EA8": "Oceania - Melanesia",
      "0451E289-BC9E-4F9D-95C0-B28A20F86BE9": "Oceania - Micronesia",
      "9EED1DD1-BA36-41F1-BEF9-63021AB24EBF": "Oceania - Polynesia",
      "084D8F39-16B0-4DFC-89F9-FE1A6EE47E9F": "CBD - Parties",
      "3AA1250A-8715-436C-B397-75FB0C9AB472": "CBD - Biosafety Protocol Parties",
      "1776454D-33DB-460B-A940-AA27A665D832": "CBD - Signatories to the Supplementary Protocol on Liability and Redress",
      "FFBF9DAA-79F3-4FEC-8A31-C60317BF7281": "CBD - Parties to the Nagoya Protocol on Access and Benefit-Sharing",
      "D50FE62D-8A5E-4407-83F8-AFCAAF708EA4": "CBD Regional Groups - Africa",
      "5E5B7AA4-2420-4147-825B-0820F7EC5A4B": "CBD Regional Groups - Asia and the Pacific",
      "6BE5B5E1-1ECF-4022-924E-160092951FB8": "CBD Regional Groups - Asia sub-region",
      "9DB40F52-ADCC-490C-9945-235CBD45CFAC": "CBD Regional Groups - Pacific sub-region",
      "942E40CA-4C23-4D3A-A0B4-736CD0EFCD54": "CBD Regional Groups - Central and Eastern Europe",
      "3D0CCC9A-A0A1-4399-8FA2-41D4D649DB0E": "CBD Regional Groups - Latin America and the Caribbean",
      "324EE0E0-0874-49CA-814C-7D5470193B40": "CBD Regional Groups - Caribbean sub-region",
      "50BDFC43-84FD-4DC9-9BDD-B9C6A3C81539": "CBD Regional Groups - Latin America sub-region",
      "0EC2E5AE-25F3-4D3A-B71F-8019BB62ED4B": "CBD Regional Groups - Western Europe and Others",
      "C7E6113A-66ED-42E1-B8BB-004EC02D3D22": "Global - Countries with Economies in Transition",
      "948125C2-F580-4357-AA0A-B6C636279E96": "Global - Developing countries",
      "BF64EC30-A6BE-4967-959F-FFE08A6A2D0A": "Global - Industrialized countries",
      "8920655D-3986-465B-837A-CE055B428A74": "Global - Least Developed Countries",
      "CE5B4B10-61B5-469B-961B-D541068A4098": "Global - Small Island Developing States",
      "209A0CEA-8525-44E8-8DF5-AD8B064F2897": "Global - Arctic countries",
      "12B485C4-C805-451A-A444-F6767E2E1B86": "Global - Asia-Pacific Economic Cooperation",
      "293E5CA9-15DB-4D83-9CAC-F406F759727A": "Global - La Francophonie",
      "BE9DD6CC-F466-4735-A851-160221D6C380": "Global - Organisation for Economic Co-operation and Development",
      "EFE67AA8-CB7B-4182-AAE8-A72E5A145D3B": "Global - The Cairns Group",
      "C5A18F9B-0E93-4FB3-B37F-67DEB5F3A696": "Global - The Commonwealth",
      "AE0C442C-E11D-4CF9-AC83-4712DA612B48": "Inland water ecosystems - Amazon basin countries",
      "5E2E72A0-1564-4F07-B085-6409F452EA40": "Inland water ecosystems - Caspian Sea countries",
      "50529AA0-D3B6-4F5D-97D4-436699900FBD": "Inland water ecosystems - Danube basin countries",
      "D04D887E-6514-41E3-96BA-967CD3208365": "Inland water ecosystems - Ganges-Brahmaputra basin countries",
      "57C5F9CB-7E61-4D47-92E9-B0D3BADDAC53": "Inland water ecosystems - Mekong basin countries",
      "9CD6B1A8-1A47-46CF-A933-58018A093601": "Inland water ecosystems - Niger basin countries",
      "E789DF4A-F71A-413C-BDFE-F33EF91AF1A0": "Inland water ecosystems - Nile basin countries",
      "FB9B3E6D-C6C1-40CA-992D-2D42908FF559": "Inland water ecosystems - Zambezi basin countries",
      "38CC1BBA-7217-4E33-B9E4-F8C063CD3FD9": "Large marine ecosystems - Arabian Sea countries",
      "D5BEB8FF-C718-4AD7-821E-A02171F72429": "Large marine ecosystems - Baltic Sea countries",
      "AA724727-4AF7-4D3C-9AD6-B38A45A353A1": "Large marine ecosystems - Black Sea countries",
      "5E884201-FBF6-4204-923C-AAC2BF11F2E3": "Large marine ecosystems - Mediterranean countries",
      "07C56CEE-BFB1-41EA-972B-1B177D2AAEF7": "Large marine ecosystems - North Sea countries",
      "CDFED5B2-F60A-4C51-B00B-548606B2A41B": "Large marine ecosystems - Red Sea countries",
      "1F130DD3-A710-406E-A8F3-A0A2D25EC0E1": "Large marine ecosystems - South China Sea countries",
      "7AE80876-D08B-4E78-AB2A-56921E1885DF": "Mountains - Alpine countries",
      "091FD5C6-AA3D-47A7-BB61-63008D092B8B": "Mountains - Andean countries",
      "E5E31D9B-FE56-4807-9CF7-E1154041C5A8": "Mountains - Carpathian countries",
      "6F1D5BE4-0F37-4848-8DE4-BE83F714A2AC": "Mountains - Caucasus countries",
      "77B4AA2B-B7BF-48D5-B6CE-397207C9060F": "Mountains - Himalayan countries",
      "AB9EBE76-796B-45B3-879B-3BA009E983CC": "Convention on Biological Diversity (CBD)",
      "6F65B204-500B-4C56-B57D-25CC3DC809F8": "Africa - regions",
      "345F2B78-DE28-475B-BA7D-81C3DA020ADF": "Africa - groups",
      "0088F30A-723A-4351-A22C-C68BEB0C56F1": "Americas - regions",
      "09D072D7-6AF9-447E-85D4-F1F265FEC3C1": "Americas - groups",
      "6F901F3F-630D-4C4C-A3CC-BDE5C7876C68": "Asia - regions",
      "40CE7EB5-2A58-4F89-A0AF-F485BBC32F81": "Asia - groups",
      "3C469DB7-E603-4E16-A828-A22A6E7123F1": "Europe - regions",
      "298D96B3-4BFB-4FBB-9E6E-26A40A35B5F6": "Europe - groups",
      "952F18B8-BB83-4C7E-9232-7B3E3EA64A3C": "Oceania - regions",
      "1C1B2D57-0F0F-423D-99C8-A048051B508C": "Ecosystems",
      "311A8E9C-582F-4952-A398-589073DBAC72": "Inland water ecosystems",
      "0C874AE8-1AEB-4818-A2F6-E5F7CAD6E265": "Large marine ecosystems",
      "38126DBD-8B41-4355-B0E5-643655CBC06E": "Mountains",
      "5D13EC43-F3E0-415E-AF67-62CCC85899AF": "Global",
      "F9EDDDBE-3FE6-4C47-BB9F-D7091A10E966": "Global - Official development assistance (ODA) countries",
      "ad": "Andorra",
      "ae": "United Arab Emirates",
      "ag": "Antigua and Barbuda",
      "al": "Albania",
      "am": "Armenia",
      "ao": "Angola",
      "ar": "Argentina",
      "at": "Austria",
      "au": "Australia",
      "az": "Azerbaijan",
      "ba": "Bosnia and Herzegovina",
      "bb": "Barbados",
      "be": "Belgium",
      "bd": "Bangladesh",
      "bf": "Burkina Faso",
      "bg": "Bulgaria",
      "bh": "Bahrain",
      "bi": "Burundi",
      "bj": "Benin",
      "bn": "Brunei Darussalam",
      "bo": "Bolivia (Plurinational State of)",
      "br": "Brazil",
      "bs": "Bahamas",
      "bt": "Bhutan",
      "bw": "Botswana",
      "by": "Belarus",
      "bz": "Belize",
      "ca": "Canada",
      "cg": "Congo",
      "ch": "Switzerland",
      "cl": "Chile",
      "cf": "Central African Republic",
      "ci": "Côte d'Ivoire",
      "ck": "Cook Islands",
      "cm": "Cameroon",
      "cn": "China",
      "co": "Colombia",
      "cr": "Costa Rica",
      "cu": "Cuba",
      "cv": "Cabo Verde",
      "cy": "Cyprus",
      "cz": "Czechia",
      "de": "Germany",
      "dj": "Djibouti",
      "dk": "Denmark",
      "dm": "Dominica",
      "dz": "Algeria",
      "ee": "Estonia",
      "eg": "Egypt",
      "do": "Dominican Republic",
      "ec": "Ecuador",
      "er": "Eritrea",
      "es": "Spain",
      "et": "Ethiopia",
      "fi": "Finland",
      "fj": "Fiji",
      "fm": "Micronesia (Federated States of)",
      "fr": "France",
      "ga": "Gabon",
      "gd": "Grenada",
      "ge": "Georgia",
      "gh": "Ghana",
      "gm": "Gambia (the)",
      "gn": "Guinea",
      "gq": "Equatorial Guinea",
      "gr": "Greece",
      "gt": "Guatemala",
      "gw": "Guinea-Bissau",
      "gy": "Guyana",
      "hn": "Honduras",
      "hr": "Croatia",
      "ht": "Haiti",
      "hu": "Hungary",
      "id": "Indonesia",
      "ie": "Ireland",
      "il": "Israel",
      "in": "India",
      "iq": "Iraq",
      "ir": "Iran (Islamic Republic of)",
      "is": "Iceland",
      "it": "Italy",
      "jm": "Jamaica",
      "jo": "Jordan",
      "jp": "Japan",
      "ke": "Kenya",
      "kg": "Kyrgyzstan",
      "kh": "Cambodia",
      "ki": "Kiribati",
      "km": "Comoros",
      "kn": "Saint Kitts and Nevis",
      "kp": "Democratic People's Republic of Korea",
      "kr": "Republic of Korea",
      "kw": "Kuwait",
      "kz": "Kazakhstan",
      "lb": "Lebanon",
      "lr": "Liberia",
      "ls": "Lesotho",
      "la": "Lao People's Democratic Republic",
      "lc": "Saint Lucia",
      "li": "Liechtenstein",
      "lk": "Sri Lanka",
      "lt": "Lithuania",
      "lu": "Luxembourg",
      "lv": "Latvia",
      "ly": "Libya",
      "ma": "Morocco",
      "mc": "Monaco",
      "md": "Republic of Moldova",
      "mg": "Madagascar",
      "mh": "Marshall Islands",
      "mk": "North Macedonia",
      "ml": "Mali",
      "mm": "Myanmar",
      "mn": "Mongolia",
      "mr": "Mauritania",
      "mt": "Malta",
      "mu": "Mauritius",
      "mv": "Maldives",
      "mw": "Malawi",
      "mx": "Mexico",
      "my": "Malaysia",
      "mz": "Mozambique",
      "na": "Namibia",
      "ne": "Niger",
      "ng": "Nigeria",
      "ni": "Nicaragua",
      "no": "Norway",
      "np": "Nepal",
      "nr": "Nauru",
      "nu": "Niue",
      "nz": "New Zealand",
      "om": "Oman",
      "pa": "Panama",
      "pe": "Peru",
      "pg": "Papua New Guinea",
      "ph": "Philippines",
      "pk": "Pakistan",
      "pl": "Poland",
      "pt": "Portugal",
      "pw": "Palau",
      "py": "Paraguay",
      "qa": "Qatar",
      "ro": "Romania",
      "rw": "Rwanda",
      "sd": "Sudan",
      "se": "Sweden",
      "ru": "Russian Federation",
      "sa": "Saudi Arabia",
      "sb": "Solomon Islands",
      "sc": "Seychelles",
      "sg": "Singapore",
      "si": "Slovenia",
      "sl": "Sierra Leone",
      "sm": "San Marino",
      "sn": "Senegal",
      "so": "Somalia",
      "sr": "Suriname",
      "st": "Sao Tome and Principe",
      "sz": "Eswatini",
      "td": "Chad",
      "sv": "El Salvador",
      "sy": "Syrian Arab Republic",
      "tg": "Togo",
      "th": "Thailand",
      "tj": "Tajikistan",
      "tm": "Turkmenistan",
      "tn": "Tunisia",
      "to": "Tonga",
      "tr": "Türkiye",
      "tt": "Trinidad and Tobago",
      "tv": "Tuvalu",
      "tz": "United Republic of Tanzania",
      "ua": "Ukraine",
      "ug": "Uganda",
      "uy": "Uruguay",
      "uz": "Uzbekistan",
      "gb": "United Kingdom of Great Britain and Northern Ireland",
      "us": "United States of America",
      "va": "Holy See",
      "vc": "Saint Vincent and the Grenadines",
      "ve": "Venezuela (Bolivarian Republic of)",
      "vn": "Viet Nam",
      "vu": "Vanuatu",
      "ws": "Samoa",
      "ye": "Yemen",
      "za": "South Africa",
      "zm": "Zambia",
      "cd": "Democratic Republic of the Congo",
      "zw": "Zimbabwe",
      "af": "Afghanistan",
      "nl": "Netherlands (Kingdom of the)",
      "sk": "Slovakia",
      "tl": "Timor-Leste",
      "me": "Montenegro",
      "eu": "European Union",
      "ss": "South Sudan",
      "rs": "Serbia",
      "ps": "State of Palestine",
      "86D464C3-B5BB-4B02-85E4-1AAD8D64CD27": "Academic or research institute",
      "8830904C-8AF4-4C2F-AADB-363D98D854DA": "Government agency (National/Federal)",
      "1C3A4FF4-9AB7-4A34-BE06-E07F575B7A32": "Government agency (Sub-national)",
      "EC872EB8-02B0-46E7-AAB0-C79AC629356A": "Indigenous peoples and local communities (IPLC)",
      "64432E86-23C9-4D9A-B835-962D8221E6CA": "Inter-governmental organization (IGO)",
      "8A265B81-3973-42ED-BB06-40ACC755E496": "Non-governmental organization (NGO)",
      "90C29DF8-D863-4255-851D-A7A6E8FDFA8F": "Private sector (business and industry)",
      "39EA5BC2-FEC4-4946-A543-A4F6E1A2F330": "Regional economic integration organization",
      "692b3eb1-a00c-437d-8903-d9b7714a7514": "UN and other specialized agency of the UN Common System",
      "AICHI-TARGET-01": "Aichi-T1. Awareness of biodiversity values",
      "AICHI-TARGET-02": "Aichi-T2. Integration of biodiversity values",
      "AICHI-TARGET-03": "Aichi-T3. Incentives",
      "AICHI-TARGET-04": "Aichi-T4. Use of natural resources",
      "AICHI-TARGET-05": "Aichi-T5. Loss of habitats",
      "AICHI-TARGET-06": "Aichi-T6. Sustainable fisheries",
      "AICHI-TARGET-07": "Aichi-T7. Areas under sustainable management",
      "AICHI-TARGET-08": "Aichi-T8. Pollution",
      "AICHI-TARGET-09": "Aichi-T9. Invasive Alien Species",
      "AICHI-TARGET-10": "Aichi-T10. Vulnerable ecosystems",
      "AICHI-TARGET-11": "Aichi-T11. Protected areas",
      "AICHI-TARGET-12": "Aichi-T12. Preventing extinctions",
      "AICHI-TARGET-13": "Aichi-T13. Agricultural biodiversity",
      "AICHI-TARGET-14": "Aichi-T14. Essential ecosystem services",
      "AICHI-TARGET-15": "Aichi-T15. Ecosystem resilience",
      "AICHI-TARGET-16": "Aichi-T16. Nagoya Protocol on ABS",
      "AICHI-TARGET-17": "Aichi-T17. NBSAPs",
      "AICHI-TARGET-18": "Aichi-T18. Traditional knowledge",
      "AICHI-TARGET-19": "Aichi-T19. Biodiversity knowledge",
      "AICHI-TARGET-20": "Aichi-T20. Resource mobilization",
      "CBD-SUBJECT-BIOMES": "Biomes",
      "CBD-SUBJECT-AGR": "Agricultural Biodiversity",
      "CBD-SUBJECT-DSHL": "Dry and Sub-Humid Lands",
      "CBD-SUBJECT-FOR": "Forest Biodiversity",
      "CBD-SUBJECT-WTR": "Inland Waters Biodiversity",
      "CBD-SUBJECT-ISL": "Island Biodiversity",
      "CBD-SUBJECT-MAR": "Marine and Coastal Biodiversity",
      "CBD-SUBJECT-MNT": "Mountain Biodiversity",
      "CBD-SUBJECT-PLR": "Polar Biodiversity",
      "CBD-SUBJECT-LEGAL-STRUCT": "Legal and Institutional Structure",
      "CBD-SUBJECT-CBD": "Secretariat of the Convention on Biological Diversity",
      "CBD-SUBJECT-COP": "Conference of the Parties",
      "CBD-SUBJECT-SBSTTA": "Subsidiary Body on Scientific, Technical and Technological Advice (SBSTTA)",
      "CBD-SUBJECT-CPB": "Cartagena Protocol on Biosafety",
      "CBD-SUBJECT-NPABS": "Nagoya Protocol on Access and Benefit-sharing",
      "CBD-SUBJECT-STRATEGY-PLAN": "Strategy and Planning",
      "CBD-SUBJECT-STRAT": "Strategic Plan 2011-2020",
      "CBD-SUBJECT-NBSAP": "National Biodiversity Strategies and Action Plans (NBSAPs)",
      "CBD-SUBJECT-TARGET": "2010 Biodiversity Target",
      "CBD-SUBJECT-IMPL-MON-REPORT": "Implementation, Monitoring and Reporting",
      "CBD-SUBJECT-NR": "National Reports",
      "CBD-SUBJECT-IND": "Indicators",
      "CBD-SUBJECT-GBO": "Global Biodiversity Outlook (GBO)",
      "CBD-SUBJECT-PART-INIT-COOP": "Partnerships and initiatives to enhance cooperation",
      "CBD-SUBJECT-AICHI-TF": "Aichi targets Task Force",
      "CBD-SUBJECT-IND-P": "Biodiversity Indicators Partnership",
      "CBD-SUBJECT-LIAISON-GROUP": "Biodiversity Liaison Group",
      "CBD-SUBJECT-BIZ": "Business",
      "CBD-SUBJECT-NAP-CB": "Capacity-building",
      "CBD-SUBJECT-CITY": "Cities and Sub national Authorities",
      "CBD-SUBJECT-CHM": "Clearing-House Mechanisms",
      "CBD-SUBJECT-STC": "Scientific and Technical Cooperation",
      "CBD-SUBJECT-FIN": "Financial Mechanism and Resources Mobilization",
      "CBD-SUBJECT-GTI": "Global Taxonomy Initiative",
      "CBD-SUBJECT-IMPA": "Impact Assessment",
      "CBD-SUBJECT-ILC": "Indigenous peoples and local communities",
      "CBD-SUBJECT-JLG": "Joint Liaison Group",
      "CBD-SUBJECT-COOP": "Memorandum of Cooperation",
      "CBD-SUBJECT-CROSS-CUTTING": "Cross-cutting Issues",
      "CBD-SUBJECT-ABS": "Access to Genetic Resources and Benefit-sharing",
      "CBD-SUBJECT-DEV": "Biodiversity for Development",
      "CBD-SUBJECT-CHPO": "Chemicals and pollution",
      "CBD-SUBJECT-CC": "Climate Change and Biodiversity",
      "CBD-SUBJECT-ETI": "Economics, Trade and Incentive Measures",
      "CBD-SUBJECT-ECOA+ECORES": "Ecosystem Approach and Restoration",
      "CBD-SUBJECT-EXS": "Ex-Situ Conservation",
      "CBD-SUBJECT-GEND": "Gender and Biodiversity",
      "CBD-SUBJECT-CPB-HTPI": "Handling of Biotechnology",
      "CBD-SUBJECT-HH": "Health and Biodiversity",
      "CBD-SUBJECT-PA": "Protected Areas",
      "CBD-SUBJECT-IPR": "Intellectual Property Rights",
      "CBD-SUBJECT-IAS": "Invasive Alien Species",
      "CBD-SUBJECT-TKIP": "Traditional Knowledge, Innovations and Practices",
      "CBD-SUBJECT-TAXONOMY": "Taxonomy",
      "CBD-SUBJECT-TOUR": "Tourism",
      "CBD-SUBJECT-OUT+CEPA": "Outreach and Education",
      "CBD-SUBJECT-IBD": "International Day for Biodiversity",
      "CBD-SUBJECT-IYB": "International Year of Biodiversity",
      "CBD-SUBJECT-UNDB": "United Nations Decade on Biodiversity",
      "CBD-SUBJECT-YOUTH": "Youth",
      "BD8F75CA-32D4-427B-A9CE-55079989A0CC": "Executive Secretary",
      "3FEF79FF-9EA2-4E3A-BEC9-2991CCDD7F3A": "Executive Secretary Featured",
      "CBD-SUBJECT-ECOA": "Ecosystem Approach",
      "CBD-SUBJECT-GSPC": "Global Strategy for Plant Conservation",
      "CBD-SUBJECT-GURT": "Genetic Use Restriction Technologies",
      "CBD-SUBJECT-LR": "Liability and Redress",
      "CBD-SUBJECT-SUSE": "Sustainable Use of Biodiversity",
      "CBD-SUBJECT-TTC": "Transfer of Technology and Cooperation",
      "CBD-SUBJECT-ICBD": "Implementation of the Convention on Biological Diversity",
      "CBD-SUBJECT-SBI": "Subsidiary Body on Implementation (SBI)",
      "CBD-SUBJECT-BTB": "Biosafety and Biotechnology",
      "CBD-SUBJECT-SDEV": "Sustainable Development / Millenium Development Goals",
      "CBD-SUBJECT-ECORES": "Ecosystem Restoration",
      "CBD-SUBJECT-ENDS": "Endangered Species",
      "CBD-SUBJECT-XCH": "Exchange of Information",
      "CBD-SUBJECT-SSC": "South-South Cooperation",
      "CBD-SUBJECT-NEW": "New & Emerging Issues",
      "CBD-SUBJECT-INS": "In-Situ Conservation",
      "CBD-SUBJECT-COMM": "Communication, Education and Public Awareness",
      "CBD-SUBJECT-AICHI": "Aichi Biodiversity Targets ",
      "CBD-SUBJECT-25TH-ANN": "25th Anniversary",
      "CBD-SUBJECT-POST2020": "Post 2020 Framework",
      "CBD-SUBJECT-DIGISTRAT": "Digital Strategy",
      "CBD-SUBJECT-KM": "Knowledge Management",
      "CBD-SUBJECT-KMGBF": "Kunming-Montreal Global Biodiversity Framework",
      "CBD-SUBJECT-DSI": "Digital Sequence Information on Genetic Resources",
      "528B1187-F1BD-4479-9FB3-ADBD9076D361": "Regional / Multilateral",
      "7437F880-7B12-4F26-AA91-CED37250DD0A": "National / Federal",
      "DEBB019D-8647-40EC-8AE5-10CA88572F6E": "Sub-national",
      "GBF-TARGET-01": "GBF-T01. All areas are planned or managed to bring loss of areas of high biodiversity importance close to zero",
      "GBF-TARGET-02": "GBF-T02. 30% of degraded areas are under effective restoration",
      "GBF-TARGET-03": "GBF-T03. 30% of areas are effectively conserved",
      "GBF-TARGET-04": "GBF-T04. Threatened species are recovering, genetic diversity is being maintained and human-wildlife conflict is being managed",
      "GBF-TARGET-05": "GBF-T05. Use, harvesting and trade of wild species is sustainable, safe and legal",
      "GBF-TARGET-06": "GBF-T06. Reduce rates of introduction and establishment of invasive alien species by 50%",
      "GBF-TARGET-07": "GBF-T07. Pollution reduced, halving nutrient loss and pesticide risk",
      "GBF-TARGET-08": "GBF-T08. Minimize impacts of climate change and ocean acidification including through nature-based solutions and/or ecosystem-based approaches",
      "GBF-TARGET-09": "GBF-T09. Management of wild species is sustainable and benefits people",
      "GBF-TARGET-10": "GBF-T10. Areas under agriculture, aquaculture, fisheries and forestry are managed sustainably",
      "GBF-TARGET-11": "GBF-T11. Nature’s contributions to people are restored, maintained and enhanced",
      "GBF-TARGET-12": "GBF-T12. Urban green and blue spaces enhanced for human well-being",
      "GBF-TARGET-13": "GBF-T13. Fair and equitable sharing of benefits from genetic resources, digital sequence information and associated traditional knowledge",
      "GBF-TARGET-14": "GBF-T14. The multiple values of biodiversity are integrated into decision-making at all levels",
      "GBF-TARGET-15": "GBF-T15. Businesses assess and disclose biodiversity dependencies, impacts and risks, and reduce negative impacts",
      "GBF-TARGET-16": "GBF-T16. Sustainable consumption choices are enabled, and food waste reduced by half",
      "GBF-TARGET-17": "GBF-T17. Strengthen biosafety and distribute benefits of biotechnology",
      "GBF-TARGET-18": "GBF-T18. Reduce harmful incentives by at least $500 billion per year",
      "GBF-TARGET-19": "GBF-T19. Financial resources increased to $200 billion per year, including $ 30 billion through international finance",
      "GBF-TARGET-20": "GBF-T20. Capacity-building and development, technology transfer, and technical and scientific cooperation for implementation is strengthened",
      "GBF-TARGET-21": "GBF-T21. Data, information and knowledge for decision-making is available",
      "GBF-TARGET-22": "GBF-T22. Ensure participation, justice, and rights for indigenous peoples and local communities, women, youth persons with disabilities and environmental defenders",
      "GBF-TARGET-23": "GBF-T23. Implementation follows a gender-responsive approach",
      "GBF-GOAL-B": "GBF-G-B. Biodiversity is sustainably used and its contributions to people are maintained, enhanced or restored",
      "GBF-GOAL-A": "GBF-G-A. Ecosystems are conserved, extinctions are halted and genetic diversity is maintained",
      "GBF-GOAL-C": "GBF-G-C. Benefits from the use of genetic resources are shared and substantially increased",
      "GBF-GOAL-D": "GBF-G-D. The biodiversity funding gap of 700 billion USD is progressively closed by ensuring adequate means of implementation are available.",
      "doc-1": "Agenda",
      "doc-2": "Statement",
      "doc-3": "Terms of Reference",
      "doc-4": "Training material",
      "doc-5": "Working Document",
      "doc-6": "Agreement",
      "doc-7": "Assessment",
      "doc-8": "Communication",
      "doc-9": "Concept note",
      "doc-10": "Factsheet",
      "doc-11": "List of participants",
      "doc-12": "Magazine",
      "doc-13": "Meeting report",
      "doc-14": "National Biodiversity Strategies and Action Plans (NBSAPs)",
      "doc-15": "National Report",
      "doc-16": "Notification",
      "doc-17": "Presentation",
      "doc-18": "Promotional material",
      "doc-19": "Publication",
      "doc-20": "Report",
      "aichiTarget": "Aichi Biodiversity Targets",
      "strategicPlanIndicator": "Strategic Plan Indicators",
      "marineEbsa": "Marine EBSAs",
      "bbiContact": "BBI Contacts",
      "bbiOpportunity": "BBI Opportunities",
      "bbiProfile": "BBI Providers of Assistance",
      "undbActor": "UNDB Actors",
      "undbParty": "UNDB Country Profile",
      "undbPartner": "UNDB Partner (depreciated)",
      "undbAction": "UNDB Actions (depreciated)",
      "submission": "Submissions",
      "nationalReport6": "Sixth National Report",
      "nationalTarget": "National Targets",
      "nationalAssessment": "Progress Assessments",
      "implementationActivity": "Implementation Activities",
      "resourceMobilisation": "Financial Reporting Framework: Reporting on baseline and progress towards 2015",
      "resourceMobilisation2020": "Financial Reporting Framework: Reporting on progress towards 2020",
      "SDG-GOAL-01": "1. No Poverty",
      "SDG-GOAL-01Alt": "End poverty in all its forms everywhere",
      "SDG-GOAL-02": "2. Zero Hunger",
      "SDG-GOAL-02Alt": "End hunger, achieve food security and improved nutrition and promote sustainable agriculture",
      "SDG-GOAL-03": "3. Good Health and Well-being",
      "SDG-GOAL-03Alt": "Ensure healthy lives and promote well-being for all at all ages",
      "SDG-GOAL-04": "4. Quality Education",
      "SDG-GOAL-04Alt": "Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all",
      "SDG-GOAL-05": "5. Gender Equality",
      "SDG-GOAL-05Alt": "Achieve gender equality and empower all women and girls",
      "SDG-GOAL-06": "6. Clean Water and Sanitation",
      "SDG-GOAL-06Alt": "Ensure availability and sustainable management of water and sanitation for all",
      "SDG-GOAL-07": "7. Affordable and Clean Energy",
      "SDG-GOAL-07Alt": "Ensure access to affordable, reliable, sustainable and modern energy for all",
      "SDG-GOAL-08": "8. Decent Work and Economic Growth",
      "SDG-GOAL-08Alt": "Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all",
      "SDG-GOAL-09": "9. Industry, Innovation and Infrastructure",
      "SDG-GOAL-09Alt": "Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation",
      "SDG-GOAL-10": "10. Reduced Inequality",
      "SDG-GOAL-10Alt": "Reduce inequality within and among countries",
      "SDG-GOAL-11": "11. Sustainable Cities and Communities",
      "SDG-GOAL-11Alt": "Make cities and human settlements inclusive, safe, resilient and sustainable",
      "SDG-GOAL-12": "12. Responsible Consumption and Production",
      "SDG-GOAL-12Alt": "Ensure sustainable consumption and production patterns",
      "SDG-GOAL-13": "13. Climate Action",
      "SDG-GOAL-13Alt": "Take urgent action to combat climate change and its impacts",
      "SDG-GOAL-14": "14. Life Below Water",
      "SDG-GOAL-14Alt": "Conserve and sustainably use the oceans, seas and marine resources for sustainable development",
      "SDG-GOAL-15": "15. Life on Land",
      "SDG-GOAL-15Alt": "Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss",
      "SDG-GOAL-16": "16. Peace and Justice Strong Institutions",
      "SDG-GOAL-16Alt": "Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels",
      "SDG-GOAL-17": "17. Partnerships to achieve the Goal",
      "SDG-GOAL-17Alt": "Strengthen the means of implementation and revitalize the Global Partnership for Sustainable Development",
      "GBF-TARGET-01Description": "Ensure that all areas are under participatory, integrated, and biodiversity inclusive spatial planning and/or effective management processes addressing land and sea use change, to bring the loss of areas of high biodiversity importance, including ecosystems of high ecological integrity, close to zero by 2030, while respecting the rights of indigenous peoples and local communities.",
      "GBF-TARGET-02Description": "Ensure that by 2030 at least 30 per cent of areas of degraded terrestrial, inland water, and coastal and marine ecosystems are under effective restoration, in order to enhance biodiversity and ecosystem functions and services, ecological integrity and connectivity.",
      "GBF-TARGET-03Description": "Ensure and enable that by 2030 at least 30 per cent of terrestrial, inland water, and of coastal and marine areas, especially areas of particular importance for biodiversity and ecosystem functions and services, are effectively conserved and managed through ecologically representative, well-connected and equitably governed systems of protected areas and other effective area-based conservation measures, recognizing indigenous and traditional territories where applicable, and integrated into wider landscapes, seascapes and the ocean, while ensuring that any sustainable use, where appropriate in such areas, is fully consistent with conservation outcomes, recognizing and respecting the rights of indigenous peoples and local communities, including over their traditional territories.",
      "GBF-TARGET-04Description": "Ensure urgent management actions to halt human induced extinction of known threatened species and for the recovery and conservation of species, in particular threatened species, to significantly reduce extinction risk, as well as to maintain and restore the genetic diversity within and between populations of native, wild and domesticated species to maintain their adaptive potential, including through in situ and ex situ conservation and sustainable management practices, and effectively manage human-wildlife interactions to minimize human-wildlife conflict for coexistence.",
      "GBF-TARGET-05Description": "Ensure that the use, harvesting and trade of wild species is sustainable, safe and legal, preventing overexploitation, minimizing impacts on non-target species and ecosystems, and reducing the risk of pathogen spill-over, applying the ecosystem approach, while respecting and protecting customary sustainable use by indigenous peoples and local communities.",
      "GBF-TARGET-06Description": "Eliminate, minimize, reduce and or mitigate the impacts of invasive alien species on biodiversity and ecosystem services by identifying and managing pathways of the introduction of alien species, preventing the introduction and establishment of priority invasive alien species, reducing the rates of introduction and establishment of other known or potential invasive alien species by at least 50 per cent, by 2030, eradicating or controlling invasive alien species especially in priority sites, such as islands. ",
      "GBF-TARGET-07Description": "Reduce pollution risks and the negative impact of pollution from all sources, by 2030, to levels that are not harmful to biodiversity and ecosystem functions and services, considering cumulative effects, including: reducing excess nutrients lost to the environment by at least half including through more efficient nutrient cycling and use; reducing the overall risk from pesticides and highly hazardous chemicals by at least half including through integrated pest management, based on science, taking into account food security and livelihoods; and also preventing, reducing, and working towards eliminating plastic pollution.",
      "GBF-TARGET-08Description": "Minimize the impact of climate change and ocean acidification on biodiversity and increase its resilience through mitigation, adaptation, and disaster risk reduction actions, including through nature-based solution and/or ecosystem-based approaches, while minimizing negative and fostering positive impacts of climate action on biodiversity. ",
      "GBF-TARGET-09Description": "Ensure that the management and use of wild species are sustainable, thereby providing social, economic and environmental benefits for people, especially those in vulnerable situations and those most dependent on biodiversity, including through sustainable biodiversity-based activities, products and services that enhance biodiversity, and protecting and encouraging customary sustainable use by indigenous peoples and local communities.",
      "GBF-TARGET-10Description": "Ensure that areas under agriculture, aquaculture, fisheries and forestry are managed sustainably, in particular through the sustainable use of biodiversity, including through a substantial increase of the application of biodiversity friendly practices, such as sustainable intensification, agroecological and other innovative approaches contributing to the resilience and long-term efficiency and productivity of these production systems and to food security, conserving and restoring biodiversity and maintaining nature’s contributions to people, including ecosystem functions and services .",
      "GBF-TARGET-11Description": "Restore, maintain and enhance nature’s contributions to people, including ecosystem functions and services, such as regulation of air, water, and climate, soil health, pollination and reduction of disease risk, as well as protection from natural hazards and disasters, through nature-based solutions and/or ecosystem-based approaches for the benefit of all people and nature. ",
      "GBF-TARGET-12Description": "Significantly increase the area and quality and connectivity of, access to, and benefits from green and blue spaces in urban and densely populated areas sustainably, by mainstreaming the conservation and sustainable use of biodiversity, and ensure biodiversity-inclusive urban planning, enhancing native biodiversity, ecological connectivity and integrity, and improving human health and well-being and connection to nature and contributing to inclusive and sustainable urbanization and the provision of ecosystem functions and services.",
      "GBF-TARGET-13Description": "Take effective legal, policy, administrative and capacity-building measures at all levels, as appropriate, to ensure the fair and equitable sharing of benefits that arise from the utilization of genetic resources and from digital sequence information on genetic resources, as well as traditional knowledge associated with genetic resources, and facilitating appropriate access to genetic resources, and by 2030 facilitating a significant increase of the benefits shared, in accordance with applicable international access and benefit-sharing instruments.",
      "GBF-TARGET-14Description": "Ensure the full integration of biodiversity and its multiple values into policies, regulations, planning and development processes, poverty eradication strategies, strategic environmental assessments, environmental impact assessments and, as appropriate, national accounting, within and across all levels of government and across all sectors, in particular those with significant impacts on biodiversity, progressively aligning all relevant public and private activities, fiscal and financial flows with the goals and targets of this framework.",
      "GBF-TARGET-15Description": "Take legal, administrative or policy measures to encourage and enable business, and in particular to ensure that large and transnational companies and financial institutions: \n\n(a) Regularly monitor, assess, and transparently disclose their risks, dependencies and impacts on biodiversity, including with requirements for all large as well as transnational companies and financial institutions along their operations, supply and value chains and portfolios;\n\n(b) Provide information needed to consumers to promote sustainable consumption patterns; \n\n(c) Report on compliance with access and benefit-sharing regulations and measures, as applicable;\n\nin order to progressively reduce negative impacts on biodiversity, increase positive impacts, reduce biodiversity-related risks to business and financial institutions, and promote actions to ensure sustainable patterns of production.",
      "GBF-TARGET-16Description": "Ensure that people are encouraged and enabled to make sustainable consumption choices including by establishing supportive policy, legislative or regulatory frameworks, improving education and access to relevant and accurate information and alternatives, and by 2030, reduce the global footprint of consumption in an equitable manner, including through halving global food waste, significantly reducing overconsumption and substantially reducing waste generation, in order for all people to live well in harmony with Mother Earth.",
      "GBF-TARGET-17Description": "Establish, strengthen capacity for, and implement in all countries biosafety measures as set out in Article 8(g) of the Convention on Biological Diversity and measures for the handling of biotechnology and distribution of its benefits as set out in Article 19 of the Convention.",
      "GBF-TARGET-18Description": "Identify by 2025, and eliminate, phase out or reform incentives, including subsidies, harmful for biodiversity, in a proportionate, just, fair, effective and equitable way, while substantially and progressively reducing them by at least 500 billion United States dollars per year by 2030, starting with the most harmful incentives, and scale up positive incentives for the conservation and sustainable use of biodiversity.",
      "GBF-TARGET-19Description": "Substantially and progressively increase the level of financial resources from all sources, in an effective, timely and easily accessible manner, including domestic, international, public and private resources, in accordance with Article 20 of the Convention, to implement national biodiversity strategies and action plans, by 2030 mobilizing at least 200 billion United States dollars per year, including by:\n\n(a) Increasing total biodiversity related international financial resources from developed countries, including official development assistance, and from countries that voluntarily assume obligations of developed country Parties, to developing countries, in particular the least developed countries and small island developing States, as well as countries with economies in transition, to at least US$ 20 billion per year by 2025, and to at least US$ 30 billion per year by 2030;\n\n(b) Significantly increasing domestic resource mobilization, facilitated by the preparation and implementation of national biodiversity finance plans or similar instruments according to national needs, priorities and circumstances;\n\n(c) Leveraging private finance, promoting blended finance, implementing strategies for raising new and additional resources, and encouraging the private sector to invest in biodiversity, including through impact funds and other instruments;\n\n(d) Stimulating innovative schemes such as payment for ecosystem services, green bonds, biodiversity offsets and credits, benefit-sharing mechanisms, with environmental and social safeguards;\n\n(e) Optimizing co-benefits and synergies of finance targeting the biodiversity and climate crises;\n\n(f) Enhancing the role of collective actions, including by indigenous peoples and local communities, Mother Earth centric actions[1]  and non-market-based approaches including community based natural resource management and civil society cooperation and solidarity aimed at the conservation of biodiversity;\n\n(g) Enhancing the effectiveness, efficiency and transparency of resource provision and use.\n\n***\n\n[1] Mother Earth-centric actions: Ecocentric and rights-based approach enabling the implementation of actions towards harmonic and complementary relationships between peoples and nature, promoting the continuity of all living beings and their communities and ensuring the non-commodification of environmental functions of Mother Earth.",
      "GBF-TARGET-20Description": "Strengthen capacity-building and development, access to and transfer of technology, and promote development of and access to innovation and technical and scientific cooperation, including through South-South, North-South and triangular cooperation, to meet the needs for effective implementation, particularly in developing countries, fostering joint technology development and joint scientific research programmes for the conservation and sustainable use of biodiversity and strengthening scientific research and monitoring capacities, commensurate with the ambition of the goals and targets of the framework.",
      "GBF-TARGET-21Description": "Ensure that the best available data, information and knowledge, are accessible to decision makers, practitioners and the public to guide effective and equitable governance, integrated and participatory management of biodiversity, and to strengthen communication, awareness-raising, education, monitoring, research and knowledge management and, also in this context, traditional knowledge, innovations, practices and technologies of indigenous peoples and local communities should only be accessed with their free, prior and informed consent[1], in accordance with national legislation.\n\n***\n\n[1] Free, prior and informed consent refers to the tripartite terminology of “prior and informed consent” or “free, prior and informed consent” or “approval and involvement.",
      "GBF-TARGET-22Description": "Ensure the full, equitable, inclusive, effective and gender-responsive representation and participation in decision-making, and access to justice and information related to biodiversity by indigenous peoples and local communities, respecting their cultures and their rights over lands, territories, resources, and traditional knowledge, as well as by women and girls, children and youth, and persons with disabilities and ensure the full protection of environmental human rights defenders.",
      "GBF-TARGET-23Description": "Ensure gender equality in the implementation of the framework through a gender-responsive approach where all women and girls have equal opportunity and capacity to contribute to the three objectives of the Convention, including by recognizing their equal rights and access to land and natural resources and their full, equitable, meaningful and informed participation and leadership at all levels of action, engagement, policy and decision-making related to biodiversity.",
      "GBF-GOAL-BDescription": "Biodiversity is sustainably used and managed and nature’s contributions to people, including ecosystem functions and services, are valued, maintained and enhanced, with those currently in decline being restored, supporting the achievement of sustainable development for the benefit of present and future generations by 2050.",
      "GBF-GOAL-ADescription": "The integrity, connectivity and resilience of all ecosystems are maintained, enhanced, or restored, substantially increasing the area of natural ecosystems by 2050; Human induced extinction of known threatened species is halted, and, by 2050, the extinction rate and risk of all species are reduced tenfold and the abundance of native wild species is increased to healthy and resilient levels; The genetic diversity within populations of wild and domesticated species is maintained, safeguarding their adaptive potential.",
      "GBF-GOAL-CDescription": "The monetary and non-monetary benefits from the utilization of genetic resources, and digital sequence information on genetic resources, and of traditional knowledge associated with genetic resources, as applicable, are shared fairly and equitably, including, as appropriate with indigenous peoples and local communities, and substantially increased by 2050, while ensuring traditional knowledge associated with genetic resources is appropriately protected, thereby contributing to the conservation and sustainable use of biodiversity, in accordance with internationally agreed access and benefit-sharing instruments",
      "GBF-GOAL-DDescription": "Adequate means of implementation, including financial resources, capacity-building, technical and scientific cooperation,  and access to and transfer of technology  to fully implement the Kunming-Montreal global biodiversity framework  are secured and equitably accessible to all Parties, especially developing countries,  in particular the least developed countries and small island developing States, as well as countries with economies in transition, progressively closing the biodiversity finance gap of 700 billion dollars per year, and aligning financial flows with the Kunming-Montreal Global Biodiversity Framework and the 2050 Vision for Biodiversity.",
      "pdfNotice": "This browser does not support PDFs. Please download the PDF to view it: ",
      "downloadPdf": "Download PDF",
      "media": "media",
      "heroHeader": "hero header",
      "Browse EBV Datasets": "Browse EBV Datasets",
      "GEO BON (Group on Earth Observations Biodiversity Observation Network Portal)": "GEO BON (Group on Earth Observations Biodiversity Observation Network Portal)",
      "GEO BON Portal": "GEO BON Portal",
      "GEO BON": "GEO BON",
      "EBV dataset": "EBV dataset",
      "EBV datasets": "EBV datasets",
      "Browse EBV Datasets for": "Browse EBV Datasets for",
      "EBV Data Portal": "EBV Data Portal",
      "Provided by the": "Provided by the",
      "The development cycle moves through several steps:": "The development cycle moves through several steps:",
      "ideas or needs are submitted": "ideas or needs are submitted",
      "requests are reviewed for correctness, correct issue type, or if they will be selected for development": "requests are reviewed for correctness, correct issue type, or if they will be selected for development",
      "tasks are prioritized for work": "tasks are prioritized for work",
      "work is being done": "work is being done",
      "and": "and",
      "final checks before release": "final checks before release",
      "Sometimes, issues may return from": "Sometimes, issues may return from",
      "or": "or",
      "back to": "back to",
      "if more work is needed": "if more work is needed",
      "Requests": "Requests",
      "Under Review": "Under Review",
      "Selected": "Selected",
      "In Progress": "In Progress",
      "Testing": "Testing",
      "Type": "Type",
      "Key": "Key",
      "Summary": "Summary",
      "Assignee": "Assignee",
      "Priority": "Priority",
      "Progress": "Progress",
      "Created": "Created",
      "Unassigned": "Unassigned",
      "Work Overview": "Work Overview",
      "Bug": "Bug",
      "Task": "Task",
      "Story": "Story",
      "Epic": "Epic",
      "Sub-task": "Sub-task",
      "Incident": "Incident",
      "Improvement": "Improvement",
      "Change": "Change",
      "Support": "Support",
      "Request": "Request",
      "New Feature": "New Feature",
      "Highest": "Highest",
      "High": "High",
      "Medium": "Medium",
      "Low": "Low",
      "Lowest": "Lowest",
      "Selected For Development": "Selected For Development",
      "View More ...": "View More ...",
      "bioland-context-description": "These cookies store the context for the Bioland tool.  One code instance caters to many websites.  The context assist to differentiate between the different websites.  Further a cookies for when you login to keep your session.  Lastly translation and view port size to assist the tool on the server. These cookies are necessary for the functionality of the website.",
      "bioland-context-cookies": "Bioland Context Cookies",
      "cookie-control-description": "We use our own cookies and third-party cookies so that we can display this website correctly and better understand how this website is used, with a view to improving the services we offer.  A decision on cookie usage permissions can be changed anytime using the cookie button that will appear after a selection has been made on this banner.",
      "cookie-control-title": "Cookies",
      "Accept all cookies": "Accept all cookies",
      "Accept only necessary cookies": "Accept only necessary cookies",
      "Learn more and customize": "Learn more and customize"
    }
  },
  "fallbackLocale": "en",
  "locale": "en",
  "precompile": {
    "strictMessage": false
  },
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "nativeName": "Afrikaans",
    "name": "Afrikaans",
    "code": "af",
    "language": "af",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/af.json"
      }
    ]
  },
  {
    "nativeName": "አማርኛ",
    "name": "Amharic",
    "code": "am",
    "language": "am",
    "dir": "rtl",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/am.json"
      }
    ]
  },
  {
    "nativeName": "العربية",
    "name": "Arabic",
    "code": "ar",
    "language": "ar",
    "dir": "rtl",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ar.json"
      }
    ]
  },
  {
    "nativeName": "Azərbaycanca",
    "name": "Azerbaijani",
    "code": "az",
    "language": "az",
    "dir": "rtl",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/az.json"
      }
    ]
  },
  {
    "nativeName": "Беларуская",
    "name": "Belarusian",
    "code": "be",
    "language": "be",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/be.json"
      }
    ]
  },
  {
    "nativeName": "Български",
    "name": "Bulgarian",
    "code": "bg",
    "language": "bg",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/bg.json"
      }
    ]
  },
  {
    "nativeName": "বাংলা",
    "name": "Bengali",
    "code": "bn",
    "language": "bn",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/bn.json"
      }
    ]
  },
  {
    "nativeName": "Bosanski",
    "name": "Bosnian",
    "code": "bs",
    "language": "bs",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/bs.json"
      }
    ]
  },
  {
    "nativeName": "Català",
    "name": "Catalan",
    "code": "ca",
    "language": "ca",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ca.json"
      }
    ]
  },
  {
    "nativeName": "Čeština",
    "name": "Czech",
    "code": "cs",
    "language": "cs",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/cs.json"
      }
    ]
  },
  {
    "nativeName": "Cymraeg",
    "name": "Welsh",
    "code": "cy",
    "language": "cy",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/cy.json"
      }
    ]
  },
  {
    "nativeName": "Dansk",
    "name": "Danish",
    "code": "da",
    "language": "da",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/da.json"
      }
    ]
  },
  {
    "nativeName": "Deutsch",
    "name": "German",
    "code": "de",
    "language": "de",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/de.json"
      }
    ]
  },
  {
    "nativeName": "རྫོང་ཁ",
    "name": "Dzongkha",
    "code": "dz",
    "language": "dz",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/dz.json"
      }
    ]
  },
  {
    "nativeName": "Ελληνικά",
    "name": "Greek",
    "code": "el",
    "language": "el",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/el.json"
      }
    ]
  },
  {
    "nativeName": "English",
    "name": "English",
    "code": "en",
    "language": "en",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/en.json"
      }
    ]
  },
  {
    "nativeName": "Esperanto",
    "name": "Esperanto",
    "code": "eo",
    "language": "eo",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/eo.json"
      }
    ]
  },
  {
    "nativeName": "Español",
    "name": "Spanish",
    "code": "es",
    "language": "es",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/es.json"
      }
    ]
  },
  {
    "nativeName": "Eesti",
    "name": "Estonian",
    "code": "et",
    "language": "et",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/et.json"
      }
    ]
  },
  {
    "nativeName": "Euskera",
    "name": "Basque",
    "code": "eu",
    "language": "eu",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/eu.json"
      }
    ]
  },
  {
    "nativeName": "فارسی",
    "name": "Persian, Farsi",
    "code": "fa",
    "language": "fa",
    "dir": "rtl",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/fa.json"
      }
    ]
  },
  {
    "nativeName": "Suomi",
    "name": "Finnish",
    "code": "fi",
    "language": "fi",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/fi.json"
      }
    ]
  },
  {
    "nativeName": "Filipino",
    "name": "Filipino",
    "code": "tl",
    "language": "tl",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/tl.json"
      }
    ]
  },
  {
    "nativeName": "Français",
    "name": "French",
    "code": "fr",
    "language": "fr",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/fr.json"
      }
    ]
  },
  {
    "nativeName": "Frysk",
    "name": "Frisian, Western",
    "code": "fy",
    "language": "fy",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/fy.json"
      }
    ]
  },
  {
    "nativeName": "Gaeilge",
    "name": "Irish",
    "code": "ga",
    "language": "ga",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ga.json"
      }
    ]
  },
  {
    "nativeName": "Gàidhlig",
    "name": "Scots Gaelic",
    "code": "gd",
    "language": "gd",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/gd.json"
      }
    ]
  },
  {
    "nativeName": "Galego",
    "name": "Galician",
    "code": "gl",
    "language": "gl",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/gl.json"
      }
    ]
  },
  {
    "nativeName": "ગુજરાતી",
    "name": "Gujarati",
    "code": "gu",
    "language": "gu",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/gu.json"
      }
    ]
  },
  {
    "nativeName": "עברית",
    "name": "Hebrew",
    "code": "he",
    "language": "he",
    "dir": "rtl",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/he.json"
      }
    ]
  },
  {
    "nativeName": "हिन्दी",
    "name": "Hindi",
    "code": "hi",
    "language": "hi",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/hi.json"
      }
    ]
  },
  {
    "nativeName": "Hrvatski",
    "name": "Croatian",
    "code": "hr",
    "language": "hr",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/hr.json"
      }
    ]
  },
  {
    "nativeName": "Kreyòl ayisyen",
    "name": "Haitian Creole",
    "code": "ht",
    "language": "ht",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ht.json"
      }
    ]
  },
  {
    "nativeName": "Magyar",
    "name": "Hungarian",
    "code": "hu",
    "language": "hu",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/hu.json"
      }
    ]
  },
  {
    "nativeName": "Հայերեն",
    "name": "Armenian",
    "code": "hy",
    "language": "hy",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/hy.json"
      }
    ]
  },
  {
    "nativeName": "Bahasa Indonesia",
    "name": "Indonesian",
    "code": "id",
    "language": "id",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/id.json"
      }
    ]
  },
  {
    "nativeName": "Íslenska",
    "name": "Icelandic",
    "code": "is",
    "language": "is",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/is.json"
      }
    ]
  },
  {
    "nativeName": "Italiano",
    "name": "Italian",
    "code": "it",
    "language": "it",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/it.json"
      }
    ]
  },
  {
    "nativeName": "日本語",
    "name": "Japanese",
    "code": "ja",
    "language": "ja",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ja.json"
      }
    ]
  },
  {
    "nativeName": "Basa Java",
    "name": "Javanese",
    "code": "jv",
    "language": "jv",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/jv.json"
      }
    ]
  },
  {
    "nativeName": "ქართული ენა",
    "name": "Georgian",
    "code": "ka",
    "language": "ka",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ka.json"
      }
    ]
  },
  {
    "nativeName": "Қазақ",
    "name": "Kazakh",
    "code": "kk",
    "language": "kk",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/kk.json"
      }
    ]
  },
  {
    "nativeName": "ភាសាខ្មែរ",
    "name": "Khmer",
    "code": "km",
    "language": "km",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/km.json"
      }
    ]
  },
  {
    "nativeName": "ಕನ್ನಡ",
    "name": "Kannada",
    "code": "kn",
    "language": "kn",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/kn.json"
      }
    ]
  },
  {
    "nativeName": "한국어",
    "name": "Korean",
    "code": "ko",
    "language": "ko",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ko.json"
      }
    ]
  },
  {
    "nativeName": "Kurdî",
    "name": "Kurdish",
    "code": "ku",
    "language": "ku",
    "dir": "rtl",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ku.json"
      }
    ]
  },
  {
    "nativeName": "Кыргызча",
    "name": "Kyrgyz",
    "code": "ky",
    "language": "ky",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ky.json"
      }
    ]
  },
  {
    "nativeName": "ພາສາລາວ",
    "name": "Lao",
    "code": "lo",
    "language": "lo",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/lo.json"
      }
    ]
  },
  {
    "nativeName": "Lietuvių",
    "name": "Lithuanian",
    "code": "lt",
    "language": "lt",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/lt.json"
      }
    ]
  },
  {
    "nativeName": "Latviešu",
    "name": "Latvian",
    "code": "lv",
    "language": "lv",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/lv.json"
      }
    ]
  },
  {
    "nativeName": "Malagasy",
    "name": "Malagasy",
    "code": "mg",
    "language": "mg",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/mg.json"
      }
    ]
  },
  {
    "nativeName": "Македонски",
    "name": "Macedonian",
    "code": "mk",
    "language": "mk",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/mk.json"
      }
    ]
  },
  {
    "nativeName": "മലയാളം",
    "name": "Malayalam",
    "code": "ml",
    "language": "ml",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ml.json"
      }
    ]
  },
  {
    "nativeName": "монгол",
    "name": "Mongolian",
    "code": "mn",
    "language": "mn",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/mn.json"
      }
    ]
  },
  {
    "nativeName": "मराठी",
    "name": "Marathi",
    "code": "mr",
    "language": "mr",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/mr.json"
      }
    ]
  },
  {
    "nativeName": "بهاس ملايو",
    "name": "Bahasa Malaysia",
    "code": "ms",
    "language": "ms",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ms.json"
      }
    ]
  },
  {
    "nativeName": "ဗမာစကား",
    "name": "Burmese",
    "code": "my",
    "language": "my",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/my.json"
      }
    ]
  },
  {
    "nativeName": "नेपाली",
    "name": "Nepali",
    "code": "ne",
    "language": "ne",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ne.json"
      }
    ]
  },
  {
    "nativeName": "Nederlands",
    "name": "Dutch",
    "code": "nl",
    "language": "nl",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/nl.json"
      }
    ]
  },
  {
    "nativeName": "Occitan",
    "name": "Occitan",
    "code": "oc",
    "language": "oc",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/oc.json"
      }
    ]
  },
  {
    "nativeName": "ਪੰਜਾਬੀ",
    "name": "Punjabi",
    "code": "pa",
    "language": "pa",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/pa.json"
      }
    ]
  },
  {
    "nativeName": "Polski",
    "name": "Polish",
    "code": "pl",
    "language": "pl",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/pl.json"
      }
    ]
  },
  {
    "nativeName": "Português, Portugal",
    "name": "Portuguese, Portugal",
    "code": "pt",
    "language": "pt",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/pt.json"
      }
    ]
  },
  {
    "nativeName": "Română",
    "name": "Romanian",
    "code": "ro",
    "language": "ro",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ro.json"
      }
    ]
  },
  {
    "nativeName": "Русский",
    "name": "Russian",
    "code": "ru",
    "language": "ru",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ru.json"
      }
    ]
  },
  {
    "nativeName": "සිංහල",
    "name": "Sinhala",
    "code": "si",
    "language": "si",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/si.json"
      }
    ]
  },
  {
    "nativeName": "Slovenčina",
    "name": "Slovak",
    "code": "sk",
    "language": "sk",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/sk.json"
      }
    ]
  },
  {
    "nativeName": "Slovenščina",
    "name": "Slovenian",
    "code": "sl",
    "language": "sl",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/sl.json"
      }
    ]
  },
  {
    "nativeName": "Shqip",
    "name": "Albanian",
    "code": "sq",
    "language": "sq",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/sq.json"
      }
    ]
  },
  {
    "nativeName": "Српски",
    "name": "Serbian",
    "code": "sr",
    "language": "sr",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/sr.json"
      }
    ]
  },
  {
    "nativeName": "Svenska",
    "name": "Swedish",
    "code": "sv",
    "language": "sv",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/sv.json"
      }
    ]
  },
  {
    "nativeName": "தமிழ்",
    "name": "Tamil",
    "code": "ta",
    "language": "ta",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ta.json"
      }
    ]
  },
  {
    "nativeName": "తెలుగు",
    "name": "Telugu",
    "code": "te",
    "language": "te",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/te.json"
      }
    ]
  },
  {
    "nativeName": "ภาษาไทย",
    "name": "Thai",
    "code": "th",
    "language": "th",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/th.json"
      }
    ]
  },
  {
    "nativeName": "Türkçe",
    "name": "Turkish",
    "code": "tr",
    "language": "tr",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/tr.json"
      }
    ]
  },
  {
    "nativeName": "ئۇيغۇرچە",
    "name": "Uyghur",
    "code": "ug",
    "language": "ug",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ug.json"
      }
    ]
  },
  {
    "nativeName": "Українська",
    "name": "Ukrainian",
    "code": "uk",
    "language": "uk",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/uk.json"
      }
    ]
  },
  {
    "nativeName": "اردو",
    "name": "Urdu",
    "code": "ur",
    "language": "ur",
    "dir": "rtl",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/ur.json"
      }
    ]
  },
  {
    "nativeName": "Tiếng Việt",
    "name": "Vietnamese",
    "code": "vi",
    "language": "vi",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/vi.json"
      }
    ]
  },
  {
    "nativeName": "简体中文",
    "name": "Chinese, Simplified",
    "code": "zh",
    "language": "zh",
    "dir": "ltr",
    "files": [
      {
        "path": "/usr/src/app/i18n/locales/zh.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
